const FlightSpecialAssistanceCodes = [
  {
    value: 'WCHS',
    label: 'Wheelchair, Traveler Can Walk To Seat',
  },
  {
    value: 'WCHR',
    label: 'Wheelchair, Traveler Can Walk Up Stairs',
  },
  {
    value: 'WCHC',
    label: 'Wheelchair, Traveler Must Be Carried',
  },
  {
    value: 'BLND',
    label: 'Blind Traveler',
  },
  {
    value: 'DEAF',
    label: 'Deaf Traveler',
  },
  {
    value: 'SRVA',
    label: 'Service Animal On Board',
  },
];

export default FlightSpecialAssistanceCodes;
